import React, { useRef, useEffect, createRef, forwardRef, useContext } from 'react';
import Sticky from 'react-stickynode';
import { Box, Column, Copy, Media, Row, Wrapper, useThemeContext } from '@honda-canada/design-system-react';
import RoutableSitecoreLink from '../RoutableSitecoreLink';
import themeStyles from './styles/ProgressBar.styles';
import useConfiguration from './config';
import useDetectSticky from './useDetectSticky';
import { useAppDispatch, useAppSelector } from '../../core/utils';
import { setCurrentAccessoryModalId, setCurrentViewMoreModalId } from '../../core/reducers/ui';
import BottomElementContext from '../Footer/service/BottomElementProvider/BottomElementContext';
import hondaRestApi from '../../core/apis/hondaRestApi';
import { MODEL_CATEGORY_NAME } from './constants';
const ContainerWithBottomBorder = themeStyles.apply(Box, 'ContainerWithBottomBorder');
const Container = themeStyles.apply(Box, 'Container');
const ContainerRow = themeStyles.apply(Row, 'ContainerRow');
const ProgressContainer = themeStyles.apply(Box, 'ProgressContainer');
const Title = themeStyles.apply(Copy, 'Title');
const TitleContainer = themeStyles.apply(Box, 'TitleContainer');
const Item = themeStyles.apply(Copy, 'Item');
const ItemUIComponent = ({ item, isItemEnabled, variant, queryParams, extendedType, isActive, scrollIntoViewCallback }, ref) => {
    const hasLink = (item === null || item === void 0 ? void 0 : item.href) || (item === null || item === void 0 ? void 0 : item.anchor);
    const dispatch = useAppDispatch();
    const { currentAccessoryModalId } = useAppSelector(state => state.ui.ConfigureBap);
    const { currentViewMoreModalId } = useAppSelector(state => state.ui.ConfigureBap);
    const isModelLink = item.key === MODEL_CATEGORY_NAME;
    let href = item === null || item === void 0 ? void 0 : item.href;
    let queryString = queryParams;
    if (isModelLink) {
        href = href === null || href === void 0 ? void 0 : href.split('?')[0];
        queryString = '';
    }
    useEffect(() => {
        var _a;
        if (typeof ref === 'function')
            return;
        if (((ref === null || ref === void 0 ? void 0 : ref.current) && isActive) || (item === null || item === void 0 ? void 0 : item.isActive)) {
            if (typeof ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView) === 'function' &&
                scrollIntoViewCallback &&
                typeof scrollIntoViewCallback === 'function') {
                scrollIntoViewCallback(ref);
            }
        }
    }, [isActive, item === null || item === void 0 ? void 0 : item.isActive]);
    const handleProgressItemClick = () => {
        if (!isItemEnabled) {
            return null;
        }
        if (isModelLink) {
            dispatch(hondaRestApi.util.resetApiState());
        }
        if (currentAccessoryModalId) {
            dispatch(setCurrentAccessoryModalId(''));
        }
        if (currentViewMoreModalId) {
            dispatch(setCurrentViewMoreModalId(''));
        }
    };
    return (React.createElement(Item, { ref: ref, variant: variant, as: isItemEnabled && hasLink && RoutableSitecoreLink, field: {
            value: {
                linktype: item === null || item === void 0 ? void 0 : item.linktype,
                href: isItemEnabled && href,
                anchor: item === null || item === void 0 ? void 0 : item.anchor,
                querystring: queryString,
            },
        }, disableHover: true, isActive: isActive !== null && isActive !== void 0 ? isActive : item === null || item === void 0 ? void 0 : item.isActive, isEnabled: isItemEnabled, "data-testid": "cy-progress-bar-item", isExtended: extendedType, onClick: handleProgressItemClick }, item === null || item === void 0 ? void 0 : item.text));
};
export const ItemUI = forwardRef(ItemUIComponent);
const ProgressBarUI = ({ fields, renderItem, enableSwipe, shouldOverrideMobileHeader }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const theme = useThemeContext();
    const title = (_c = (_b = (_a = fields === null || fields === void 0 ? void 0 : fields.data) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.title) === null || _c === void 0 ? void 0 : _c.value;
    const headingOption = (_f = (_e = (_d = fields === null || fields === void 0 ? void 0 : fields.data) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.headingOption) === null || _f === void 0 ? void 0 : _f.value;
    const items = ((_j = (_h = (_g = fields === null || fields === void 0 ? void 0 : fields.data) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.items) !== null && _j !== void 0 ? _j : []).map(item => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return ({
            key: item === null || item === void 0 ? void 0 : item.name,
            isActive: !!((_a = item === null || item === void 0 ? void 0 : item.isActive) === null || _a === void 0 ? void 0 : _a.value),
            text: (_d = (_c = (_b = item === null || item === void 0 ? void 0 : item.progressUrl) === null || _b === void 0 ? void 0 : _b.item) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.text,
            href: (_g = (_f = (_e = item === null || item === void 0 ? void 0 : item.progressUrl) === null || _e === void 0 ? void 0 : _e.item) === null || _f === void 0 ? void 0 : _f.value) === null || _g === void 0 ? void 0 : _g.href,
            linktype: (_k = (_j = (_h = item === null || item === void 0 ? void 0 : item.progressUrl) === null || _h === void 0 ? void 0 : _h.item) === null || _j === void 0 ? void 0 : _j.value) === null || _k === void 0 ? void 0 : _k.linktype,
            anchor: (_o = (_m = (_l = item === null || item === void 0 ? void 0 : item.progressUrl) === null || _l === void 0 ? void 0 : _l.item) === null || _m === void 0 ? void 0 : _m.value) === null || _o === void 0 ? void 0 : _o.anchor,
        });
    });
    const itemsRefs = useRef(new Array(items === null || items === void 0 ? void 0 : items.length).fill(null).map(() => createRef()));
    const { isExtended } = useConfiguration(items === null || items === void 0 ? void 0 : items.length);
    const { stickyPosition, isSticky } = useDetectSticky(isExtended, shouldOverrideMobileHeader);
    const { setDealerBannerHiddenOnScroll } = useContext(BottomElementContext);
    useEffect(() => {
        if (!shouldOverrideMobileHeader) {
            return;
        }
        setDealerBannerHiddenOnScroll(isSticky);
    }, [shouldOverrideMobileHeader, isSticky, setDealerBannerHiddenOnScroll]);
    const zIndex = ((isSticky && isExtended ? (_k = theme === null || theme === void 0 ? void 0 : theme.zIndices) === null || _k === void 0 ? void 0 : _k.sectionNav : (_l = theme === null || theme === void 0 ? void 0 : theme.zIndices) === null || _l === void 0 ? void 0 : _l.subNavigationBar) || 0) - 1;
    const extendedType = isExtended ? 'extended' : 'normal';
    const progressItems = items === null || items === void 0 ? void 0 : items.map((item, index) => {
        const itemRef = itemsRefs.current[index];
        return renderItem(item, extendedType, itemRef);
    });
    if (!Array.isArray(items) || !items.length)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Media, { lessThan: "desktop" },
            React.createElement(Sticky, { top: stickyPosition.mobile, innerZ: zIndex },
                React.createElement(Container, { id: "ProgressBar", isExtended: extendedType, "data-testid": "cy-progress-bar" },
                    React.createElement(ProgressContainer, { isExtended: extendedType, enableSwipe: enableSwipe, "data-testid": "cy-progress-bar-container" },
                        React.createElement(Title, { as: headingOption, "data-testid": "cy-progress-bar-title", isExtended: extendedType }, title),
                        progressItems)))),
        React.createElement(Media, { greaterThan: "smallDesktop" },
            React.createElement(Sticky, { top: stickyPosition.desktop, innerZ: zIndex },
                React.createElement(ContainerWithBottomBorder, { id: "ProgressBar", "data-testid": "cy-progress-bar" },
                    React.createElement(Wrapper, null,
                        React.createElement(ContainerRow, null,
                            React.createElement(Column, { width: [1, 1 / 4], pl: ['zero'], pr: ['zero'] },
                                React.createElement(TitleContainer, null,
                                    React.createElement(Title, { isExtended: extendedType, as: headingOption, "data-testid": "cy-progress-bar-title" }, title))),
                            React.createElement(Column, { width: [1, 3 / 4], pl: [0, 0, 7] },
                                React.createElement(ProgressContainer, { "data-testid": "cy-progress-bar-container", isExtended: isExtended }, progressItems)))))))));
};
export default ProgressBarUI;
